import { onBeforeUnmount, onMounted, unref } from "vue";

// DRY the "press Escape to dismiss" behaviour for the bespoke bt-portal/Teleport
// modals that don't go through OverlayLayer/BtModal (which already handle it).
// Only fires the close callback while the modal is actually open, and always
// tears the listener down on unmount so it can't leak (the class of bug that
// CardBoxModal's module-level listener had).
//
//   useEscapeToClose(isOpenRef, () => (isOpen.value = false));
//
// `isOpen` may be a ref or a plain getter-backed value; it's read via unref.
export function useEscapeToClose(isOpen, close) {
  const onKeydown = (event) => {
    if (event.key === "Escape" && unref(isOpen)) {
      close();
    }
  };

  onMounted(() => document.addEventListener("keydown", onKeydown));
  onBeforeUnmount(() => document.removeEventListener("keydown", onKeydown));
}
